const ClickToEditDirective = function () {
    var editorTemplate = '<form name="clickToEdit"><div class="click-to-edit">' +
        '<div ng-hide="view.editorEnabled">' +
        '{{view.value}} ' +
        '<br /><div class="grey-text ultra-small"><a href="" ng-click="activate()">Edit</a></div>' +
        '</div>' +
        '<div ng-show="view.editorEnabled">' +
        '<input ng-show="!rows" ng-model="view.editableValue" required>' +
        '<textarea ng-show="rows" rows={{rows}} ng-model="view.editableValue" required shift-enter></textarea>' +
        '<a class="cursor-pointer" href ng-click="save()">Save</a>' +
        ' or ' +
        '<a class="cursor-pointer" ng-click="disable()">cancel</a>.' +
        '</div>' +
        '</div></form>';

    return {
        restrict: "A",
        replace: true,
        template: editorTemplate,
        scope: {
            model: "=clickToEdit",
            property: "@",
            onConfirmed: "&",
            onDelete: "&",
            rows: '@?'
        },
        controller: ["$scope", function ($scope) {

            $scope.view = {
                value: $scope.model[$scope.property],
                editableValue: $scope.model[$scope.property],
                editorEnabled: false
            };

            $scope.activate = function () {
                $scope.view.editorEnabled = true;
            };

            $scope.disable = function () {
                $scope.view.editorEnabled = false;
            };

            $scope.delete = function () {
                $scope.onDelete();
            };

            $scope.save = function () {
                if (!$scope.clickToEdit.$valid) {
                    $scope.disable();
                    return;
                }
                $scope.model[$scope.property] = $scope.view.editableValue;
                $scope.view.value = $scope.view.editableValue;
                $scope.onConfirmed();
                $scope.disable();
            };
        }]
    }
};

export { ClickToEditDirective };